import React, { useContext, useEffect, useState } from "react";

import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { UserContext } from "../../../context";
import firebase from "../../../firebase";
import ProjectCommentsDialog from "./Project Comments/ProjectCommentsDialog";
import ProjectComponentFrame from "./ProjectComponentFrame";

export default function ProjectTextBoxComponent(props) {
    const { currentUserData } = useContext(UserContext);
    const [projectKey, setProjectKey] = useState("");
    const [text, setText] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [allowComments, setAllowComments] = useState(false);
    const [commentsDialogOpen, setCommentsDialogOpen] = useState(false);

    useEffect(() => {
        if (currentUserData && props.component) {
            setProjectKey(props.projectKey);
            setIsEditing(props.isEditing);
            setText(props.component.text);
            setAllowComments(props.component.allowComments);
        }
    }, [currentUserData, props.component, props.isEditing, props.projectKey]);

    const handleAllowCommentsChange = (event) => {
        setAllowComments(event.target.checked);

        if (projectKey !== "") {
            firebase
                .database()
                .ref("projects")
                .child(projectKey)
                .child("components")
                .child(props.component.key)
                .child("allowComments")
                .set(event.target.checked);
        }
    };

    function handleTextFieldChange(event) {
        const newValue = event.target.value;

        if (event.target.id === "text") {
            setText(newValue);
            props.component.text = newValue;

            if (projectKey !== "") {
                firebase
                    .database()
                    .ref("projects")
                    .child(projectKey)
                    .child("components")
                    .child(props.component.key)
                    .child("text")
                    .set(newValue);
            }
        }
    }

    return (
        <>
            <ProjectComponentFrame
                component={props.component}
                isEditing={isEditing}
                label="Text"
                onDelete={() => props.delete(props.component)}
                onMoveUp={() => props.moveUp(props.component)}
                onMoveDown={() => props.moveDown(props.component)}
            >
                {isEditing ? (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                        }}
                    >
                        <TextField
                            fullWidth
                            multiline
                            minRows={5}
                            value={text}
                            id="text"
                            onChange={handleTextFieldChange}
                            label="Text content"
                            placeholder="Add your text"
                        />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={allowComments}
                                    onChange={handleAllowCommentsChange}
                                />
                            }
                            label="Allow comments"
                        />
                    </Box>
                ) : (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 2,
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                flex: 1,
                                whiteSpace: "pre-wrap",
                                overflowWrap: "anywhere",
                            }}
                        >
                            {text}
                        </Typography>
                        {allowComments && (
                            <Button
                                variant="outlined"
                                startIcon={<MessageOutlinedIcon />}
                                onClick={() => setCommentsDialogOpen(true)}
                                sx={{ flexShrink: 0 }}
                            >
                                Comments
                            </Button>
                        )}
                    </Box>
                )}
            </ProjectComponentFrame>
            <ProjectCommentsDialog
                open={commentsDialogOpen}
                onClose={() => setCommentsDialogOpen(false)}
                component={props.component}
                canEdit={props.canEdit}
                projectKey={projectKey}
            />
        </>
    );
}
